import React, { useState } from 'react';
import { Button } from '@mui/material';
import { submitComment } from 'components/JobComments/submit';
import './CreateJobAdvanced.scss';
import { useModalContext } from '../ModalContext';
import AutoForm from './AutoForm';
import {
  Alert,
  Grid,
} from '@mui/material';
import { useJobsContext } from 'components/JobList';
import { JobTypeCard } from './JobTypeCard';
import { jobTypeInfo } from './jobTypeInfo';
import {CommentSection} from 'components/JobComments';


const CreateJobAdvanced = () => {
  const { formState, setFormState, onSubmitJob, isUpdate } = useModalContext();
  const { readonly } = useJobsContext();

  const [comment, setComment] = useState('');
  const submitAndComment = async (event) => {
    event.preventDefault();
    const validate = jobTypeInfo[formState.values.jobType]?.validate;
    if (validate) {
      const errors = validate(formState.values);
      if (errors.length > 0) {
        setFormState({
          ...formState,
          errorMessage: errors.join('\n')
        });
        return;
      }
    }
    await submitComment({
      content: comment,
      jobId: formState.values._id
    });
    onSubmitJob(event);
  };

  console.log(formState)
  const Form = jobTypeInfo[formState.values.jobType]?.form || AutoForm;
  return <Grid spacing={3} sx={{backgroundColor: "#eee", padding: "5px"}}>

    <Grid item sx={{marginBottom: "10px"}}>
      <JobTypeCard />
    </Grid>

    <Grid item>
      <Form />
    </Grid>

    {isUpdate && <Grid item>
      <CommentSection
        jobId={formState.values._id}
        onChange={setComment}
        readonly={readonly}
        value={comment}
        />
      </Grid>
    }

    {formState.errorMessage && (
      <Grid item sx={{ marginBottom: '10px' }}>
        <Alert severity="error" sx={{ whiteSpace: 'pre-line' }}>
          {formState.errorMessage}
        </Alert>
      </Grid>
    )}

    <Grid item>
      <Button
        color="primary"
        disabled={readonly}
        onClick={submitAndComment}
        variant="contained"
      >
       Save Job
      </Button>
    </Grid>

  </Grid>
};

export default CreateJobAdvanced;
